module.exports = __webpack_public_path__ + "static/media/mode5.3fba839e.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode5.gif
// module id = 1457
// module chunks = 110